import React from 'react';
import { SVGProps } from './type';

const IconMinimizeArrow = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6715 3.04756C16.062 2.65704 16.062 2.02387 15.6715 1.63335C15.2809 1.24282 14.6478 1.24282 14.2572 1.63335L11.2977 4.59291L11.2977 4.00712C11.2977 3.45484 10.85 3.00712 10.2977 3.00712C9.7454 3.00712 9.29769 3.45484 9.29769 4.00712L9.29769 7.00712C9.29769 7.55941 9.7454 8.00712 10.2977 8.00712L13.2977 8.00712C13.85 8.00712 14.2977 7.55941 14.2977 7.00712C14.2977 6.45484 13.85 6.00712 13.2977 6.00712L12.7119 6.00712L15.6715 3.04756ZM4.63102 8.67379C4.07874 8.67379 3.63102 9.1215 3.63102 9.67379C3.63102 10.2261 4.07874 10.6738 4.63102 10.6738L5.21681 10.6738L2.25725 13.6333C1.86672 14.0239 1.86672 14.657 2.25725 15.0476C2.64777 15.4381 3.28094 15.4381 3.67146 15.0476L6.63102 12.088L6.63102 12.6738C6.63102 13.2261 7.07874 13.6738 7.63102 13.6738C8.18331 13.6738 8.63102 13.2261 8.63102 12.6738L8.63102 9.67379C8.63102 9.1215 8.18331 8.67379 7.63102 8.67379L4.63102 8.67379Z"
      transform="translate(0, 1) scale(1.4)"
      fill={fill}
    />
  </g>
);

export default IconMinimizeArrow;
